export default "__VITE_ASSET__B6XB5aju__"